import React from 'react';
import { Card, CardHeader, CardTitle, CardContent } from './ui/card';
import { Badge } from './ui/badge';
import { mockData } from '../mock';

const Leadership = () => {
  const { leadership } = mockData;

  return (
    <section id="leadership" className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-white via-indigo-50 to-white relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-full h-full pointer-events-none">
        <div className="absolute top-10 right-10 w-96 h-96 bg-indigo-100 rounded-full filter blur-3xl opacity-20"></div>
        <div className="absolute bottom-10 left-10 w-80 h-80 bg-blue-100 rounded-full filter blur-3xl opacity-20"></div>
      </div>

      <div className="max-w-7xl mx-auto relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="px-4 py-2 bg-blue-50 text-blue-700 rounded-full text-sm font-semibold">
            Our Team
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mt-6 mb-4">
            Leadership Team
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            70+ years combined expertise with unreplicable network access across EMEA & APAC
          </p>
        </div>

        {/* Leadership Grid (text-only, no images) */}
        <div className="grid md:grid-cols-4 gap-8">
          {leadership.map((leader) => (
            <Card
              key={leader.id}
              className="border-2 border-gray-100 hover:border-blue-200 hover:shadow-xl transition-all duration-300 cursor-pointer"
            >
              <CardHeader className="pt-6 pb-4">
                <div className="flex flex-col items-center text-center">
                  <CardTitle className="text-2xl font-bold text-gray-900 mb-2">
                    {leader.name}
                  </CardTitle>
                  <p className="text-blue-600 font-semibold mb-4">{leader.role}</p>
                </div>
              </CardHeader>
              <CardContent>
                <p className="text-gray-600 mb-6 leading-relaxed text-sm">{leader.expertise}</p>
                <div className="flex flex-wrap gap-2 justify-center">
                  {leader.highlights.map((highlight, idx) => (
                    <Badge key={idx} variant="outline" className="border-blue-200 text-blue-700 hover:bg-blue-50 transition-colors">
                      {highlight}
                    </Badge>
                  ))}
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Leadership;
